<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="stockAreaSelected"
    :clearable="!unclearable"
    :items="areaItems"
    :loading="Loading"
    :search-input.sync="search"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('CurrentPosition.Fields.areas')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
    :disabled="disabled"
    :readonly="readonly"
  ></v-autocomplete>
</template>

<script>
import stockAreas from "@/api/stock_areas";
import i18n from '../../i18n';

export default {
  name: "SearcherArea",

  props: {
    value: Object,
    stockId: Number,
    noLabel: Boolean,
    label: String,
    dense: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
  },

  computed: {
    areaItems() {
      return this.stock_area.map((e) => {
        const Description = e.area_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == e.id
            )
          : false;
        return Object.assign({}, e, { Description, disabled });
      });
    },
  },

  data: () => ({
    stock_area: [],
    Loading: false,
    search: "",
    stockAreaSelected: null,
  }),

  mounted() {
    this.getStockAreaFromAPI();
  },

  methods: {
    getStockAreaFromAPI() {
      this.Loading = true;
      stockAreas.fetchAllForSelect({stock_id: this.stockId})
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stock_area = response.data.stock_areas;
              //适配没有设置库区的库位
              this.stock_area.unshift({
                id:0,
                area_name:i18n.t("StockArea.noStockArea"),
              })
              
              if(this.$route.query.stock_area_id){
                let result = this.stock_area.filter((v) => {
                  return v.id == this.$route.query.stock_area_id;
                });
                this.stockAreaSelected = result[0];
              }
            }
            this.Loading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.Loading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockAreaSelected = this.value;
      },
    },
    stockAreaSelected: {
      handler() {
        this.$emit("input", this.stockAreaSelected);
      },
    },
    stockId: {
      handler() {
        this.getStockAreaFromAPI();
      }
    }
  },
};
</script>
